<template>
  <DashboardMenu />
  <div class="container">
    <div class="row">
      <h1 class="h1">
        <router-link to="/dashboard/donors">Доноры</router-link> / Донор
        {{ $route.params.id }}
      </h1>
    </div>

    <div class="mdc-card">
      <div class="mdc-card-wrapper__text-section">
        <div class="card__title">Настройки донора</div>
      </div>
      <div class="inputs-row">
        <div class="input-col">
          <h5>Proxy</h5>
          <label
            class="
              mdc-text-field mdc-text-field--outlined mdc-text-field--no-label
            "
          >
            <span class="mdc-notched-outline">
              <span class="mdc-notched-outline__leading"></span>
              <span class="mdc-notched-outline__trailing"></span>
            </span>
            <input
              class="mdc-text-field__input"
              type="text"
              aria-label="Label"
              placeholder="Proxy: socks://login:password@ip:port"
              v-model="donor.proxy"
            />
          </label>
        </div>
        <div class="input-col">
          <h5>UserAgent</h5>
          <label
            class="
              mdc-text-field mdc-text-field--outlined mdc-text-field--no-label
            "
          >
            <span class="mdc-notched-outline">
              <span class="mdc-notched-outline__leading"></span>
              <span class="mdc-notched-outline__trailing"></span>
            </span>
            <input
              class="mdc-text-field__input"
              type="text"
              aria-label="Label"
              placeholder="UserAgent"
              v-model="donor.userAgent"
            />
          </label>
        </div>
        <div class="input-col">
          <h5>Password</h5>
          <label
            class="
              mdc-text-field mdc-text-field--outlined mdc-text-field--no-label
            "
          >
            <span class="mdc-notched-outline">
              <span class="mdc-notched-outline__leading"></span>
              <span class="mdc-notched-outline__trailing"></span>
            </span>
            <input
              class="mdc-text-field__input"
              type="text"
              aria-label="Label"
              placeholder="Пароль"
              v-model="donor.password"
            />
          </label>
        </div>
        <div class="input-col">
          <h5>Куки</h5>
          <label
            class="
              mdc-text-field mdc-text-field--outlined mdc-text-field--no-label
            "
          >
            <span class="mdc-notched-outline">
              <span class="mdc-notched-outline__leading"></span>
              <span class="mdc-notched-outline__trailing"></span>
            </span>

            <input
              class="mdc-text-field__input"
              type="text"
              aria-label="Label"
              placeholder="Пароль"
              v-model="donor.cookie"
            />
          </label>
        </div>
        <div class="input-col">
          <h5>DTSG токен</h5>
          <label
            class="
              mdc-text-field mdc-text-field--outlined mdc-text-field--no-label
            "
          >
            <span class="mdc-notched-outline">
              <span class="mdc-notched-outline__leading"></span>
              <span class="mdc-notched-outline__trailing"></span>
            </span>

            <input
              class="mdc-text-field__input"
              type="text"
              disabled
              aria-label="Label"
              placeholder="dtsg Токен"
              v-model="donor.dtsgToken"
            />
          </label>
        </div>
        <div class="input-col">
          <h5>
            Статус аккаунта (текущий:
            {{ donor.status ? 'Активен' : 'Заблокирован' }})
          </h5>
          <div
            style="display: flex; flex-direction: row"
            class="select-mode-row"
          >
            <select class="mdc-text-field__input" v-model="donor.status">
              <option value="true" :selected="donor.status">Активен</option>
              <option value="false" :selected="!donor.status">
                Заблокирован
              </option>
            </select>
          </div>
        </div>
        <button
          class="mdc-button"
          @click="saveDonor"
          :disabled="!donor.cookie || !donor.password"
        >
          <span class="mdc-button__ripple"></span>
          <span class="mdc-button__label">Сохранить</span>
        </button>
        <button
          class="mdc-button"
          @click="updateDTSG"
          :disabled="!donor.cookie || !donor.password"
        >
          <span class="mdc-button__ripple"></span>
          <span class="mdc-button__label">Обновить DTSG</span>
        </button>
      </div>
    </div>

    <div class="mdc-card">
      <div class="mdc-card-wrapper__text-section">
        <div class="card__title">Список проверок</div>
      </div>
      <div class="mdc-data-table">
        <!-- <div class="card">
          <div class="card-title">

          </div>
          <div class="card-body"> -->
        <div class="mdc-data-table__table-container">
          <table class="mdc-data-table__table">
            <thead>
              <tr class="mdc-data-table__header-row">
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Id
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Аккаунтов
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Ошибок
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  % Ошибок
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Тип
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Время чека
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Дата
                </th>
              </tr>
            </thead>
            <tbody class="mdc-data-table__content">
              <tr
                v-for="(check, i) in checks"
                :key="i"
                class="mdc-data-table__row"
              >
                <th class="mdc-data-table__cell" scope="row">{{ check.id }}</th>
                <td class="mdc-data-table__cell">{{ check.accounts }}шт.</td>
                <td class="mdc-data-table__cell">{{ check.errors }}шт.</td>
                <td class="mdc-data-table__cell">
                  {{ ((check.errors / check.accounts) * 100).toPrecision(3) }}%
                </td>
                <td class="mdc-data-table__cell">{{ check.type }}</td>
                <td class="mdc-data-table__cell">
                  {{ Number(check.checkTime).toPrecision(2) }}s
                </td>
                <td class="mdc-data-table__cell">
                  {{ moment(check.createdAt).fromNow() }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import DashboardMenu from '@/components/DashboardMenu.vue';
import moment from 'moment';

export default {
  data() {
    return {
      donor: {},
      checks: [],
      active: 0,
      id: this.$route.params.id
    };
  },
  created: function() {
    this.moment = moment;
  },
  computed: {},

  methods: {
    async getDonors() {
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.get('donors/' + this.id, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log(resp);
        this.donor = resp.data;
        this.checks = resp.data.Checks;
      } catch (error) {
        console.log(error.msg);
      }
    },
    async saveDonor() {
      if (this.donor.cookie.length == 0 || this.donor.password.length == 0) {
        this.showToaster('Введите пароль и куки!');
        return;
      }
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.patch('donors/' + this.id, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          data: {
            proxy: this.donor.proxy,
            userAgent: this.donor.userAgent,
            password: this.donor.password,
            cookie: this.donor.cookie
          }
        });
        this.donor = resp.data;
        this.showToaster('Аккаунт обновлен успешно');
      } catch (error) {
        console.log(error.msg);
      }
    },
    async updateDTSG() {
      if (this.donor.cookie.length == 0 || this.donor.password.length == 0) {
        this.showToaster('Введите пароль и куки!');
        return;
      }
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.get(
          'donors/' + this.id + '/updateDTSG',
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
        console.log(resp)
        if (resp.data.status === 'success') {
          this.donor.dtsgToken = resp.data.dtsgToken;
          this.showToaster('DTSG обновлен успешно');
        }
      } catch (error) {
        console.log(error.msg);
      }
    },
    showToaster(msg) {
      this.$toast.show(msg, {
        position: 'top'
        // duration: false,
      });
    }
  },

  mounted() {
    this.getDonors();
  },
  components: { DashboardMenu }
};
</script>


<style lang="scss" scoped>
@import '../styles/material-components-web.min.css';

.container {
  flex-direction: column;
  width: 1280px;
  max-width: 90%;
  margin: 0 auto;
}

.mdc-data-table__header-cell {
  height: 56px;
  font-weight: bold;
}

.stats-columns {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.stats-column {
  width: 25%;
  padding: 10px;
}

.mdc-card-wrapper__text-section {
  padding: 16px;
}

.card__title {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  text-decoration: inherit;
  text-transform: inherit;
}

.card__subhead {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.card__supporting-text {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.select-mode-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

select {
  padding: 8px 12px;
  border: 1px solid #333;
  opacity: 0.6;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0178571429em;
}

.mdc-data-table__pagination-navigation a {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.47);
  font-size: 24px;
  cursor: pointer;
  &:hover {
    color: rgba(0, 0, 0, 0.87);
    transition: 0.3s all ease;
  }
}

.mdc-data-table__pagination-navigation .pagination-link-wrapper {
  margin-right: 5px;
  width: 48px;
  height: 48px;
  padding: 12px;
}

.mdc-data-table__pagination-navigation button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.inputs-row {
  display: flex;
  flex-wrap: wrap;
  .input-col {
    width: 50%;
    padding: 15px;
    h5 {
      margin-bottom: 10px;
    }
    label {
      width: 100%;
    }
  }

  .mdc-button {
    margin-left: 15px;
    color: #333;
    border: 1px solid #333;
    width: 20%;
    display: flex;
    margin-bottom: 15px;
  }

  .mdc-button:disabled {
    margin-left: 15px;
    color: #777;
    border: 1px solid #777;
    width: 20%;
    display: flex;
    margin-bottom: 15px;
  }
}

.select-mode-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

select {
  padding: 8px 12px;
  border: 1px solid #333;
  opacity: 0.6;
  height: 56px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0178571429em;
}

// .danger {
//   background: rgb(240, 128, 128, 0.7);
// }

// .success {
//   background: rgba(144, 238, 144, 0.7);
// }
</style>